import styles from './Modal.module.scss';

import cn from 'classnames';

import CloseIcon from './images/close.svg?react';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

let modalCounter = 1000;

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  minHeight?: string;
  portal?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isVisible,
  onClose,
  children,
  minHeight = '400px',
  portal = true,
}) => {
  const [isAnimationReady, setIsAnimationReady] = useState(false);
  const [modalZIndex, setModalZIndex] = useState(1000);

  useEffect(() => {
    if (isVisible) {
      modalCounter += 1;
      setModalZIndex(modalCounter);

      const timer = setTimeout(() => setIsAnimationReady(true), 10);
      return () => {
        clearTimeout(timer);
        setIsAnimationReady(false);
      };
    } else {
      setIsAnimationReady(false);
    }
  }, [isVisible]);

  const modalContent = (
    <div
      onClick={onClose}
      className={cn(styles.blur, isVisible && styles.visible)}
      style={{ zIndex: modalZIndex }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={cn(styles.modalContent, isAnimationReady && styles.visible)}
        style={{ minHeight, zIndex: modalZIndex + 1 }}
      >
        <CloseIcon
          onClick={onClose}
          className={styles.close}
          style={{ zIndex: modalZIndex + 2 }}
        />
        {children}
      </div>
    </div>
  );

  if (portal) {
    const appElement = document.getElementById('app');
    if (appElement) {
      return createPortal(modalContent, appElement);
    }
  }

  return modalContent;
};
